import React from "react";
import DropdownMultiGroupSelect from "patient-ping-remedy/packages/dropdown-multi-group";
import {css} from "@emotion/css";
import {
  Filters,
  Field,
  FieldLabel,
  FilterDropdownMultiGroupSelectWrapper
} from '@/components/pages/analytics/FilterDropDown.styles';

type Option = { label: string; value: string };

type FilterDropdownProps = {
    label: string;
    value: string[];
    onChange: (value: string[]) => void;
    options: Option[];
    loading?: boolean;
};

export function FilterDropdown({ label, value, onChange, options, loading }: FilterDropdownProps) {
  const dropdownOptions = options.map(opt => ({ id: opt.value, label: opt.label, value: opt.value }));
  const selectedValues = dropdownOptions.filter(opt => value.includes(opt.value));

  return (
    <Field>
      <FieldLabel>{label}</FieldLabel>
      <FilterDropdownMultiGroupSelectWrapper>
        <DropdownMultiGroupSelect
          className={css({ fontSize: '1.6rem' })}
          handleChange={(e) => onChange(e?.map(item => item.value) || [])}
          isRequiredField={false}
          isLoading={loading}
          noOptionsMessage={() => loading ? 'Loading results...' : 'No results found'}
          label=""
          options={dropdownOptions}
          value={selectedValues}
          menuPlacement="auto"
          id={`filter-dropdown-${label.toLowerCase().replace(/\s+/g, '-')}`}
        />
      </FilterDropdownMultiGroupSelectWrapper>
    </Field>
  );
}

export function FiltersRow({
  rosters,
  showIncompleteForm = false,
  assigneeOptions,
  showCRFCompleted = false,
  onFiltersChange,
  assigneeLoading,
} : {
  rosters?: { rosterOptions: { label: string; value: string }[] },
  showIncompleteForm?: boolean,
  assigneeOptions?: { label: string; value: string }[],
  assigneeLoading?: boolean,
  showCRFCompleted?: boolean,
  onFiltersChange?: (filters: {
    rosterIds: string[],
    assigneeIds: string[],
    formTypes: string[],
    crfCompleted: string[]
  }) => void
}) {
  const groupOptions = [
    ...(rosters?.rosterOptions || [])
  ];
  const assignees = assigneeOptions || [];
  const formOptions = [
    { label: "Admission CRF Form", value: "Admission CRF Form" },
    { label: "Discharge CRF Form", value: "Discharge CRF Form" }
  ];
  const crfCompletedOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
    { label: "N/A", value: "N/A" }
  ];

  const [rosterIds, setRosterIds] = React.useState<string[]>([]);
  const [assigneeIds, setAssigneeIds] = React.useState<string[]>([]);
  const [formTypes, setFormTypes] = React.useState<string[]>([]);
  const [crfCompleted, setCrfCompleted] = React.useState<string[]>([]);

  React.useEffect(() => {
    onFiltersChange?.({ rosterIds, assigneeIds, formTypes, crfCompleted });
  }, [rosterIds, assigneeIds, formTypes, crfCompleted, onFiltersChange]);

  return (
    <Filters>
      <FilterDropdown label="Group" value={rosterIds} onChange={setRosterIds} options={groupOptions} />
      <FilterDropdown
        label="Assignee"
        value={assigneeIds}
        onChange={setAssigneeIds}
        options={assignees}
        loading={assigneeLoading}
      />
      {showCRFCompleted && (
        <FilterDropdown label="CRF completed status" value={crfCompleted} onChange={setCrfCompleted}
          options={crfCompletedOptions} />
      )}
      {showIncompleteForm && (
        <FilterDropdown label="Incomplete form" value={formTypes} onChange={setFormTypes} options={formOptions} />
      )}
    </Filters>
  );
}
